import { memo } from 'react'
import { usePostAppointmentContext } from '../../context/PostAppointmentContext/PostAppointmentProvider'
import Note from './Note'
import Review from './Review'
import Orders from './Orders'
import Timeline from './Timeline'
import Initial from './Initial'
import RecommendedProgram from './RecommendedProgram'
import AmendReview from './AmendReview'

const PostAppointmentRouter: React.FC = () => {
  const { currentScreen } = usePostAppointmentContext()

  switch (currentScreen) {
    case 'initial':
      return <Initial />
    case 'recommended-program':
      return <RecommendedProgram />
    case 'orders':
      return <Orders />
    case 'timeline':
      return <Timeline />
    case 'note':
      return <Note />
    case 'review':
      return <Review />
    case 'amend-review':
      return <AmendReview />
    default:
      return <Initial />
  }
}

export default memo(PostAppointmentRouter)
